import React from 'react';
import PropTypes from 'prop-types';
import { Select } from 'antd';
import { OLDEST_YEAR, NEWEST_YEAR } from 'helpers/statisticsHelpers';
import styles from './Statistics.module.scss';

const { Option, OptGroup } = Select;

const StatisticsFilters = ({
  zones,
  zone,
  displayType,
  year,
  type,
  onFiltersChange,
}) => (
  <div className={styles.filters}>
    {zones && (
      <Select
        defaultValue={zone}
        disabled={!zones.length}
        className={styles.filters__zone}
        onChange={value => onFiltersChange({ zone: value })}
      >
        <OptGroup label="Forêts">
          {!zones.length
            ? <Option value={zone}>Forêts</Option>
            : zones.map((zoneName, index) =>
              <Option key={zoneName} value={index}>{zoneName}</Option>)
          }
        </OptGroup>
      </Select>
    )}
    <Select
      defaultValue={year}
      className={styles.filters__years}
      onChange={value => onFiltersChange({ year: value })}
    >
      <OptGroup label="Année">
        {Array.from({ length: (NEWEST_YEAR - OLDEST_YEAR) + 1 }, (_, i) => (
          <Option key={NEWEST_YEAR - i} value={NEWEST_YEAR - i}>{NEWEST_YEAR - i}</Option>
        ))}
      </OptGroup>
    </Select>
    <Select
      defaultValue={type}
      disabled={!zones.length}
      className={styles.filters__type}
      onChange={value => onFiltersChange({ type: value })}
    >
      <OptGroup label="Afficher le">
        <Option value="events">Nombre d'évenements</Option>
        <Option value="participants">Nombre de participants</Option>
      </OptGroup>
    </Select>
    <Select
      defaultValue={displayType}
      disabled={!zones.length}
      className={styles.filters__displayType}
      onChange={value => onFiltersChange({ displayType: value })}
    >
      <OptGroup label="Filtrer par">
        <Option value="graph">Catégorie d'activités</Option>
        <Option value="table">Catégorie et sous-catégorie d'activités</Option>
      </OptGroup>
    </Select>
  </div>
);

StatisticsFilters.propTypes = {
  zones: PropTypes.array,
  zone: PropTypes.number,
  displayType: PropTypes.string,
  year: PropTypes.number,
  type: PropTypes.string,
  onFiltersChange: PropTypes.func,
};

StatisticsFilters.defaultProps = {
  zone: 0,
  displayType: 'graph',
  type: 'events',
  year: NEWEST_YEAR,
  onFiltersChange: () => {},
};

export default StatisticsFilters;



// WEBPACK FOOTER //
// ./src/components/Statistics/StatisticsFilters.js